import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { RAGL_TRANSACTION_BASE_PATH } from '../../../../../../../../features/clearing-ledger/transaction/ragl-transaction-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/transaction/_transaction')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'ragl-transaction-list',
        label: 'Core',
        to: RAGL_TRANSACTION_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
